export const priceCollectionGuard = 'GET /prices';
export const priceResourceGuard = 'GET /prices/d+';
export const addPriceResourceGuard = 'POST /prices';
export const editPriceResourceGuard = 'PUT /prices/d+';
export const deletePriceResourceGuard = 'DELETE /prices/d+';
